import { UnwrapNestedRefs } from 'vue';
import Tenant from '@/app/auth/models/Tenant';
import { MODE } from '@/app/enums/tenant/Mode';

const useTenantLiveModeModal = () => {
    const name = `${Tenant.prefix}:mode:modal` as const;
    const tenant = ref<UnwrapNestedRefs<Tenant>>();
    // Where to land after the switch. Set by whoever opened the modal, so a flow with a next step
    // (activating e-invoicing) does not dump the user back on the dashboard.
    const redirectTo = ref<string>();
    const { switchMode, isLoading } = useTenantSwitchMode();
    useModal(name, (payload: { tenant: UnwrapNestedRefs<Tenant>; redirectTo?: string }) => {
        tenant.value = payload.tenant;
        redirectTo.value = payload.redirectTo;
    });
    const goLive = () =>
        switchMode({
            tenant: tenant.value as UnwrapNestedRefs<Tenant>,
            mode: MODE.LIVE,
            redirectTo: redirectTo.value,
        });

    const open = (tenant: UnwrapNestedRefs<Tenant>, redirectTo?: string) => useEvent(`${name}:open`, { tenant, redirectTo });

    return {
        tenant,
        goLive,
        isLoading,
        modal: {
            open,
            name,
        },
    };
};

export default useTenantLiveModeModal;
